import React from "react";

const DOWN_EVENTS   = ["pointerdown","touchstart","mousedown"];
const SCROLL_EVENTS = ["wheel","touchmove"];
const CTX_EVENTS    = ["contextmenu"];

function guardDom(el, { disableScroll = true } = {}) {
  if (!el) return () => {};

  const stopDown = (e) => { e.stopPropagation(); }; // don't preventDefault; allow click/up to bubble
  DOWN_EVENTS.forEach(t => el.addEventListener(t, stopDown, { passive: true }));
  const stopCtx = (e) => { e.stopPropagation(); };
  CTX_EVENTS.forEach(t => el.addEventListener(t, stopCtx, { passive: true }));

  const stopScroll = (e) => e.stopPropagation();
  if (disableScroll) SCROLL_EVENTS.forEach(t => el.addEventListener(t, stopScroll, { passive: true }));

  // iOS niceties
  el.style.touchAction = el.style.touchAction || "manipulation";
  el.style.WebkitTapHighlightColor = "transparent";
  el.style.pointerEvents = "auto";

  return () => {
    DOWN_EVENTS.forEach(t => el.removeEventListener(t, stopDown));
    CTX_EVENTS.forEach(t  => el.removeEventListener(t, stopCtx));
    if (disableScroll) SCROLL_EVENTS.forEach(t => el.removeEventListener(t, stopScroll));
  };
}

export class MapEventGuardLegacy extends React.Component {
  constructor(p){ super(p); this.ref = React.createRef(); this.unsub = null; }
  componentDidMount(){ this.unsub = guardDom(this.ref.current, this.props); }
  componentWillUnmount(){ if (this.unsub) this.unsub(); }
  render(){
    const { as:Tag="div", className="", style={}, children, ...rest } = this.props;
    return <Tag ref={this.ref} className={`map-ui-guard ${className}`} style={style} {...rest}>{children}</Tag>;
  }
}

export class MapControlGuardLegacy extends React.Component {
  constructor(p){
    super(p);
    this.c = typeof document !== "undefined" ? document.createElement("div") : null;
    if (this.c) {
      this.c.className = `leaflet-control map-ui-guard ${p.className||""}`;
      Object.assign(this.c.style, p.style || {});
    }
    this.unsub = null;
    this.ctrl = null;
    this.mounted = false;
  }
  componentDidMount(){
    const { map, position="topright" } = this.props;
    if (!this.c) return;
    this.mounted = true;
    this.unsub = guardDom(this.c, this.props);
    import("leaflet").then((module) => {
      if (!this.mounted || !this.c) return;
      const L = module.default || module;
      const C = L.Control.extend({ onAdd: () => this.c, onRemove: () => {} });
      this.ctrl = new C({ position });
      if (map) this.ctrl.addTo(map);
    }).catch(() => {});
  }
  componentWillUnmount(){
    this.mounted = false;
    if (this.unsub) this.unsub();
    try { this.props.map && this.ctrl && this.props.map.removeControl(this.ctrl); } catch {}
  }
  render(){ return this.c ? React.createPortal(this.props.children, this.c) : null; }
}

export function attachLeafletGuards(node, opts){ return guardDom(node, opts); }